var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_56207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2047 11.2491C31.6439 9.55829 35.4467 8.74066 39.277 8.86844C43.1073 8.99623 46.8471 10.0655 50.166 11.9818C50.4803 12.1632 50.7479 12.4154 50.9476 12.7184C51.1473 13.0214 51.2735 13.3668 51.3163 13.7271L51.3327 14.0024V44.3358C51.3327 44.7453 51.2248 45.1477 51.0201 45.5024C50.8153 45.8571 50.5207 46.1516 50.166 46.3564C49.8113 46.5612 49.4089 46.669 48.9993 46.669C48.5898 46.669 48.1874 46.5612 47.8327 46.3564C44.995 44.7181 41.776 43.8556 38.4993 43.8556C35.2227 43.8556 32.0037 44.7181 29.166 46.3564C28.8113 46.5612 28.4089 46.669 27.9993 46.669C27.5898 46.669 27.1874 46.5612 26.8327 46.3564C24.0995 44.7782 21.0109 43.9187 17.8554 43.8583C14.6998 43.7979 11.5805 44.5386 8.78902 46.0111L8.02602 46.4311L7.78568 46.5338L7.67135 46.5711L7.41468 46.6318L7.27235 46.6551L6.99935 46.6691H6.90135L6.64468 46.6411L6.46502 46.6084L6.21302 46.5338L5.91902 46.4031L5.69735 46.2724L5.48968 46.1161L5.34968 45.9854L5.17935 45.7941L5.03002 45.5864L4.97868 45.5024L4.90402 45.3624L4.80135 45.1221L4.76402 45.0078L4.70335 44.7511L4.68002 44.6088L4.67068 44.4944L4.66602 44.3358V14.0024C4.66603 13.5928 4.77385 13.1905 4.97864 12.8358C5.18343 12.4811 5.47798 12.1865 5.83268 11.9818C9.1516 10.0655 12.8914 8.99623 16.7217 8.86844C20.552 8.74066 24.3548 9.55829 27.794 11.2491L27.9993 11.3518L28.2047 11.2491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15.6797L28 41.4397",
    stroke: "#E6E6E6",
    strokeWidth: 2.24,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_56207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheory);
export default __webpack_public_path__ + "static/media/theory.d9c89d2c6b12fd72ece11f56710e65ae.svg";
export { ForwardRef as ReactComponent };